import { render, staticRenderFns } from "./ModalSelection.vue?vue&type=template&id=37625c4c&"
import script from "./ModalSelection.vue?vue&type=script&lang=js&"
export * from "./ModalSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports